import(/* webpackMode: "eager" */ "/app/src/app/common/layout/AppLayout.tsx")